import Signin from '@/pages/Signin/Signin';
import ForgetPassword from '@/pages/ForgetPassword/ForgetPassword';
import Signup from '@/pages/Signup/Signup';
import Main from '@/pages/Main/Main';

import Home from '@/pages/Home/Home';
import Chats from '@/pages/Chats/Chats';
import Teachers from '@/pages/Teachers/Teachers';
import Whiteboard from '@/pages/Whiteboard/Whiteboard';
import Fudao from '@/pages/Fudao/Fudao';

import Account from '@/pages/Account/Account';
import FudaoHistory from '@/pages/FudaoHistory/FudaoHistory';
import ChargeHistory from '@/pages/ChargeHistory/ChargeHistory';
import IncomeHistory from '@/pages/IncomeHistory/IncomeHistory';
import WrongAnswerHistory from '@/pages/WrongAnswerHistory/WrongAnswerHistory';
import Settings from '@/pages/Settings/Settings';

import Question from '@/pages/Question/Question';
import Profile from '@/pages/Profile/Profile';

import IcelinkTest from '@/pages/IcelinkTest/IcelinkTest';

export const routes = [
  {path: '/', redirect: {name: 'Signin'}, meta: {auth: false}},
  {path: '/signin', component: Signin, name: 'Signin', meta: {auth: false}},
  {path: '/forget_password', component: ForgetPassword, name: 'ForgetPassword', meta: {auth: false}},
  {path: '/signup', component: Signup, name: 'Signup', meta: {auth: false}},
  {path: '/app', component: Main, name: 'Main', redirect: {name: 'Home'}, children: [
    {path: 'home', component: Home, name: 'Home', meta: {layout: 'full'}},
    {path: 'chats', component: Chats, name: 'Chats'},
    {path: 'teachers', component: Teachers, name: 'Teachers'},
    {path: 'whiteboard', component: Whiteboard, name: 'Whiteboard', meta: {layout: 'full'}},
    {path: 'fudao', component: Fudao, name: 'Fudao', meta: {layout: 'full'}},
    {path: 'question', component: Question, name: 'Question', meta: {layout: 'full'}},
    {path: 'profile', component: Profile, name: 'Profile', redirect: {name: 'Account'}, meta: {layout: 'full'}, children: [
      {path: 'account', component: Account, name: 'Account'},
      {path: 'fudao-history', component: FudaoHistory, name: 'FudaoHistory'},
      {path: 'charge-history', component: ChargeHistory, name: 'ChargeHistory'},
      {path: 'income-history', component: IncomeHistory, name: 'IncomeHistory'},
      {path: 'wrong-answer-history', component: WrongAnswerHistory, name: 'WrongAnswerHistory'}
    ]},
    {path: 'settings', component: Settings, name: 'Settings', meta: {layout: 'full'}},
    {path: 'icelinktest', component: IcelinkTest, name: 'IcelinkTest', meta: {layout: 'full'}}
  ]}
  // {path: '*', component: NotFound, name: 'not-found'}
];

export const getRoute = (routeName) => {
  function getRoutePathByName(routes, routeName) {
    return routes.find((route) => {
      if (route.name === routeName) {
        return true;
      }
      if (route.children instanceof Array) {
        getRoutePathByName(route.children, routeName);
      }
      return false;
    });
  }

  return getRoutePathByName(routes, routeName);
};
